import { combineReducers } from 'redux';
import isLoading from './is-loading/isLoading.reducer';
import accommodationsSets from './accommodations-sets/accommodationsSets.reducer';
import error from './error/error.reducer';
import { filtersReducer as filters } from './filters/filters.reducer';
import { isDataFetched } from './is-data-fetched/isDataFetched.reducer';
import { isPmrChecked } from './is-pmr-checked/isPmrChecked.reducer';
import filteredAccommodations from './filtered-accommodations/filteredAccommodations.reducer';
import filteredAccommodationsAlternativesByComfortReducer from './filtered-accommodations-alternatives-by-comfort/filteredAccommodationsAlternativesByComfort.reducer';
import isLoadingFilteredAccommodationsAlternativesByComfort from './is-loading/isLoadingFilteredAccommodationsAlternativesByComfort.reducer';
export const additionalAccommodations = combineReducers({
  error,
  isLoading,
  accommodationsSets,
  filters,
  filteredAccommodations,
  isLoadingFilteredAccommodationsAlternativesByComfort,
  filteredAccommodationsAlternativesByComfort: filteredAccommodationsAlternativesByComfortReducer,
  isDataFetched,
  isPmrChecked,
});
